module.exports = __webpack_public_path__ + "img/symbol_5.c3e0de50.png";